export default function TopBanner() {
    return (
        <a
            href="https://bcnext.it/"
            target="_blank"
            rel="noreferrer"
            className="fixed top-0 left-0 right-0 z-[60] bg-[#0A2540] hover:bg-[#0d2d4d] transition-colors border-b border-white/5 group block"
            data-testid="top-banner"
            aria-label="Realizzato da BC Next — agenzia digitale della Ciociaria"
        >
            <div className="flex items-center justify-center gap-2 px-3 py-2 md:py-3 whitespace-nowrap overflow-hidden">
                {/* Mobile compact (< sm) */}
                <span className="sm:hidden flex items-center gap-2 text-bone-50 font-mono text-[10px] tracking-[0.1em]">
                    <span>Realizzato da</span>
                    <span className="text-flash font-semibold">BC Next</span>
                    <span className="text-flash font-semibold group-hover:translate-x-0.5 transition-transform">→</span>
                </span>

                {/* Small tablets (sm to md) */}
                <span className="hidden sm:flex md:hidden items-center gap-2 text-bone-50 font-mono text-[11px] tracking-[0.1em]">
                    <span>Realizzato da</span>
                    <span className="text-flash font-semibold">BC Next</span>
                    <span className="text-bone-400">·</span>
                    <span className="text-flash font-semibold">Scopri →</span>
                </span>

                {/* Desktop (md+) */}
                <span className="hidden md:flex items-center gap-3 text-bone-50 font-mono text-[12px] tracking-[0.15em]">
                    <span>Realizzato da</span>
                    <span className="text-flash font-semibold">BC Next</span>
                    <span className="text-bone-400">— agenzia digitale della Ciociaria</span>
                    <span className="text-flash font-semibold group-hover:translate-x-1 transition-transform ml-2">
                        Scopri BC Next →
                    </span>
                </span>
            </div>
        </a>
    );
}
